import React, { PureComponent } from 'react';
import { OpenHoursExceptionModel, OpenHoursModel } from '../../api/core/core.types';
import { timeToDisplayFormat } from '../../helpers/timeHelper';

interface DayCardProps {
  day: string;
  openHours?: OpenHoursModel[];
  openHoursExceptions?: OpenHoursExceptionModel[];
  isClosed?: boolean;
}

export default class DayCard extends PureComponent<DayCardProps> {

  formatTime = (time: string) => {
    if (time.length === 3) time = `0${time}`;

    return [ time.slice(0, 2), ':', time.slice(2) ].join('');
  };

  getOpenHours = () => {
    // eslint-disable-next-line react/no-array-index-key
    if (this.props.openHours && this.props.openHours.length) return this.props.openHours.map((o, inx) => <div className="font-weight-normal" key={inx}>{`${timeToDisplayFormat(String(o.startTime))} - ${timeToDisplayFormat(String(o.endTime))}`}</div>);
    if (this.props.openHoursExceptions && this.props.openHoursExceptions.length) return this.props.openHoursExceptions.map((o, inx) => <div className="font-weight-normal" key={inx}>{`${timeToDisplayFormat(String(o.startTime))} - ${timeToDisplayFormat(String(o.endTime))}`}</div>);

    if (this.props.isClosed) return (<div>Closed</div>);

    return (<div>Open 24</div>);
  };

  render() {
    return (
      <div className="open-hours-container mr-2">
        <label className="text-bold">{this.props.day}</label>
        {this.getOpenHours()}
      </div>
    );
  }
}
